// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgSpeakerOff24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M4.03033 2.96967C3.73744 2.67678 3.26256 2.67678 2.96967 2.96967C2.67678 3.26256 2.67678 3.73744 2.96967 4.03033L6.98788 8.04854L6.736 8.25H3C2.58579 8.25 2.25 8.58579 2.25 9V15L2.25685 15.1018C2.30651 15.4678 2.6203 15.75 3 15.75H6.737L11.5315 19.5857C12.0226 19.9785 12.75 19.6289 12.75 19V13.8107L17.5102 18.5709C17.2471 18.8654 17.257 19.3177 17.5398 19.6004C17.8225 19.8831 18.2747 19.8928 18.5691 19.6298L19.9697 21.0303C20.2626 21.3232 20.7374 21.3232 21.0303 21.0303C21.3232 20.7374 21.3232 20.2626 21.0303 19.9697L19.5613 18.5006C22.7679 14.2874 22.4476 8.24814 18.6004 4.39975C18.3076 4.10681 17.8327 4.10674 17.5398 4.39959C17.2468 4.69244 17.2467 5.16731 17.5396 5.46025C20.8001 8.72172 21.1166 13.8119 18.4891 17.4285L16.562 15.5013C18.301 13.2465 18.1371 9.99711 16.0704 7.92975C15.7776 7.63681 15.3027 7.63674 15.0098 7.92959C14.7168 8.22244 14.7167 8.69731 15.0096 8.99025C16.4895 10.4706 16.6494 12.771 15.4891 14.4285L12.75 11.6893V5C12.75 4.37112 12.0226 4.02149 11.5315 4.41435L8.16649 7.10583L4.03033 2.96967ZM8.05532 9.11598L7.46852 9.58565C7.33554 9.69204 7.1703 9.75 7 9.75H3.75V14.25H7C7.13624 14.25 7.26924 14.2871 7.38508 14.3564L7.46852 14.4143L11.25 17.44V12.3107L8.05532 9.11598ZM11.25 10.1893L9.23358 8.17292L11.25 6.559V10.1893Z"
				/>
			</Svg>
		);
	}
);
SvgSpeakerOff24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgSpeakerOff24;
